import { useConfigStore } from "@core/stores/config";
import { AppContentLayoutNav } from "@layouts/enums";

export const useSkins = () => {
  const configStore = useConfigStore();

  const layoutAttrs = computed(() => ({
    verticalNavAttrs: {
      wrapper: "div",
      wrapperProps: {
        class:
          configStore.isVerticalNavSemiDark &&
          configStore.appContentLayoutNav === AppContentLayoutNav.Vertical
            ? "v-theme--dark"
            : undefined,
      },
    },
  }));

  const injectSkinClasses = () => {
    if (typeof document !== "undefined") {
      const bodyClasses = document.body.classList;
      const genSkinClass = (_skin?: string) => `skin--${_skin}`;

      watch(
        () => configStore.skin,
        (val, oldVal) => {
          bodyClasses.remove(genSkinClass(oldVal));
          bodyClasses.add(genSkinClass(val));
        },
        { immediate: true },
      );
    }
  };

  return {
    injectSkinClasses,
    layoutAttrs,
  };
};
